var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getSuccessResult, getExpiredPasswordResult, failedLoginResult, getTermsResult, getApiErrorResult, PlatformLoginError, changePasswordResult } from "../types";
export class PlatformLoginResultHandler {
    constructor(player, responsiveService, gateway) {
        this.player = player;
        this.responsiveService = responsiveService;
        this.gateway = gateway;
    }
    getLoginResult(request) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield request;
                return this.handlePlatformLoginResult(result);
            }
            catch (e) {
                return this.handleLoginError(e);
            }
        });
    }
    handlePlatformLoginResult(result) {
        return __awaiter(this, void 0, void 0, function* () {
            if (result.prt) {
                this.player.processLoginApiError({ message: "password-expired" });
                return getExpiredPasswordResult(result.prt);
            }
            else if (!result.token) {
                console.warn(`Unhandled response ${JSON.stringify(result)}`);
                return failedLoginResult;
            }
            else {
                return this.jwtTokenLogin(result.token, result.storablePassword);
            }
        });
    }
    jwtTokenLogin(token, storablePassword) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.responsiveService.login(token);
                this.gateway.setToken(token);
                this.player.continueLogin(result);
                return getSuccessResult(storablePassword);
            }
            catch (error) {
                console.warn(error);
                if (error.message.includes("restrictedLegalText")) {
                    return getTermsResult(token, error.message.split(":")[1]);
                }
                else {
                    yield this.gateway.forceLoadAnonymousToken();
                    this.player.processLoginError(error);
                    return failedLoginResult;
                }
            }
        });
    }
    handleLoginError(error) {
        console.warn(error);
        if (error instanceof PlatformLoginError) {
            this.player.processLoginApiError(error);
            return this.handlePlatformLoginError(error);
        }
        else {
            this.player.processLoginError(error);
            return failedLoginResult;
        }
    }
    handlePlatformLoginError(error) {
        if (error.apiErrorString === "PASSWORD_CHANGE_REQUIRED") {
            return changePasswordResult;
        }
        return getApiErrorResult(error);
    }
}
//# sourceMappingURL=PlatformLoginResultHandler.js.map